// libraries.
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// slice.
import {
  ReviewOption,
  getSelectedTask,
  getShowModal,
  setDefaultState,
  setShowModal,
} from '@domains/documents-review/store/slices/document-review-slice';
import {
  getCountry,
  getEmail,
} from '@domains/user/store/slices/user-slice/user-slice';
import { useGetListTasksQuery } from '@domains/documents-review/store/api-slices/list-tasks.endpoints';
import { useUpdateTaskStatusMutation } from '@domains/documents-review/store/api-slices/update-task-status.endpoints';

// components.
import { ModalForm } from '@shared/ModalForm/ModalForm';

const BUSINESS_TYPE = 'real_estate,committee';

export const AbortTaskModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const email = useSelector(getEmail);
  const country = useSelector(getCountry);
  const showModal = useSelector(getShowModal);
  const taskData = useSelector(getSelectedTask);

  const id = taskData?.id;
  const nid = taskData?.nid;

  const { refetch } = useGetListTasksQuery(
    {
      country: country,
      status: 'pending,progress',
      business_type: BUSINESS_TYPE,
    },
    { skip: !country }
  );

  const [mutateAbort, { isLoading, isSuccess, isError }] =
    useUpdateTaskStatusMutation();

  const handleAbandon = () => {
    if (!id || !nid) return;

    mutateAbort({
      id: id,
      agent: email,
      country: country,
      status: 'pending',
      nid: nid,
    });
  };

  useEffect(() => {
    if (isError) {
      toast.error('Error al reasignar esta tarea', {
        toastId: 'errorAbortTask',
      });
    } else if (isSuccess) {
      refetch();
      toast.success('Tarea reasignada correctamente', {
        toastId: 'successRejectTask',
      });
      dispatch(setShowModal(false));
      dispatch(setDefaultState());
      navigate('/document-audit/tasks');
    }
  }, [isError, isSuccess]);

  return (
    <ModalForm
      disabled={isLoading}
      show={showModal === ReviewOption.ABORT}
      option={ReviewOption.ABORT}
      subtitle="Estás a punto de reasignar esta tarea. ¿Deseas continuar?."
      submitLabel="Reasignar"
      onSave={handleAbandon}
    />
  );
};
